<template>
<div class="entrance-mask">
  <div class="entrance-box">
    <div class="entrance-box-icon">
      <img src="@/assets/img/login/push-icon.png" alt="publish">
    </div>
    <p v-html="$t('login.customerInfo')"></p>
    <div class="entrance-box-btn" @click="entrance(-1)">
      {{$t("login.customerIn")}}
    </div>
  </div>
  <div class="entrance-box right">
    <img class="door" src="@/assets/img/login/door.png" alt="door">
    <div class="entrance-box-icon">
      <img src="@/assets/img/login/tag-icon.png" alt="do">
    </div>
    <p v-html="$t('login.userInfo')"></p>
    <div class="entrance-box-btn" @click="entrance(1)">
      {{$t("login.userIn")}}
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'login-role',
  data () {
    return {
      role: 0
    }
  },
  methods: {
    entrance (role) {
      let host = document.location.host
      let origin = document.location.origin
      if (role === -1) {
        // for requester
        if (this.isValidIP(host)) {
          window.location.href = `${origin}/login?role=requester`
        } else {
          window.location.href = origin.replace(/(www|worker)./, 'requester.')
        }
      } else {
        // for worker
        if (this.isValidIP(host)) {
          window.location.href = `${origin}/login?role=worker`
        } else {
          window.location.href = origin.replace(/(www|requester)./, 'worker.')
        }
      }
    },
    isValidIP (ip) {
      var patt = /((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}/
      return patt.test(ip)
    }
  }
}
</script>
<style lang="less" scoped>
.entrance-mask {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: linear-gradient(to right, #3C73D3 0, #001148 100%);
  overflow: hidden;
}
.entrance-box {
  width: 50%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9;
  p {
    position: relative;
    margin-bottom: 1rem;
    text-align: center;
    color: #fff;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      width: 40vw;
      height: 40vw;
      transform: translate(-50%, -10%);
      border-radius: 50%;
      background-image: linear-gradient(to bottom,  rgba(77, 128, 226, .4) 0, rgba(53, 98, 198, 0) 100%);
      z-index: -1;
    }
  }
  &.right {
    background: #eee;
    .door {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      transform: translateX(-98%);
    }
    p {
      color: #666666;
      &::after {
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, .4) 0, #eee 100%);
      }
    }
    .entrance-box-btn {
      background-image: linear-gradient(to right,#4491DF 0, #0066EC 100%);
      &::after {
        display: none;
      }
    }
  }
}
.entrance-box-icon {
  position: relative;
  width: 40%;
  max-width: 350px;
  margin-bottom: 1.5rem;
  img {
    width: 100%;
  }
}
.entrance-box-btn {
  position: relative;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  border-radius: 50px;
  padding: .3em 2em;
  &:hover {
    cursor: pointer;
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 2px solid #fff;
    border-radius: 50px;
  }
}
@keyframes goLogin {
  0% {
    transform: scale(2) translateX(-5px);
  }
  50% {
    transform: scale(2) translateX(3px);
  }
  100% {
    transform: scale(2) translateX(-5px);
  }
}
@media screen and (max-width: 768px) {
  .entrance-mask {
    flex-direction: column;
  }
  .entrance-box-icon {
    width: 70%;
  }
  .entrance-box {
    width: 100%;
    &:first-child {
      display: none;
    }
    p::after {
      width: 100vw;
      height: 100vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login-role/app.vue